import { C } from '#integrations';
import styles from './Table.module.css';
const SIZE_CLASS_MAP = {
    '12x': styles.ColSize12x,
    '18x': styles.ColSize18x,
    '24x': styles.ColSize24x,
    '32x': styles.ColSize32x,
    '41x': styles.ColSize41x,
    '48x': styles.ColSize48x,
    '56x': styles.ColSize56x,
    '64x': styles.ColSize64x,
    '90x': styles.ColSize90x,
};
const GROW_CLASS_MAP = {
    fixed: styles.ColGrowFixed,
    flex: styles.ColGrowFlex,
    'flex-2': styles.ColGrowFlex2,
    'flex-3': styles.ColGrowFlex3,
    'flex-4': styles.ColGrowFlex4,
    'no-shrink': styles.ColGrowNoShrink,
};
const UTILITY_CLASS_MAP = {
    overflow: styles.ColUtilOverflow,
    'justify-end': styles.ColUtilJustifyEnd,
    'justify-center': styles.ColUtilJustifyCenter,
    pointer: styles.ColUtilPointer,
};
export const sortMultiple = (data, sortConfig) => {
    let localSortConfig = [...sortConfig];
    const sortRecursive = (a, b) => {
        const currentSortFunction = localSortConfig.pop();
        if (!currentSortFunction) {
            /**
             * On reaching the recursion bottom,
             * reset the sorting list:
             */
            localSortConfig = [...sortConfig];
            return 0;
        }
        else {
            const result = currentSortFunction(a, b);
            if (result !== 0) {
                /**
                 * On reaching the recursion bottom,
                 * reset the sorting list:
                 */
                localSortConfig = [...sortConfig];
                return result;
            }
            else {
                return sortRecursive(a, b);
            }
        }
    };
    data.sort(sortRecursive);
};
/**
 * Maps columnSize, columnGrow, and columnUtility props to CSS class names.
 * Falls back to custom className if provided.
 */
export const getColumnClassName = (columnConfig) => {
    const { className, columnGrow, columnSize, columnUtility } = columnConfig;
    // If no sizing props provided, return custom className
    if (!columnSize && !columnGrow && !columnUtility) {
        return className;
    }
    const sizeClass = columnSize ? SIZE_CLASS_MAP[columnSize] : undefined;
    const growClass = columnGrow ? GROW_CLASS_MAP[columnGrow] : undefined;
    const utilityClasses = columnUtility
        ? (Array.isArray(columnUtility) ? columnUtility : [columnUtility]).map((utility) => UTILITY_CLASS_MAP[utility])
        : [];
    // Combine all classes (custom className can still be added)
    return C(className, sizeClass, growClass, ...utilityClasses);
};
